import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { shortAddress } from "./overlay/format";
import { Collection } from "./routes/Collection";
import { Help } from "./routes/Help";
import { Landing } from "./routes/Landing";
import { LinkLobby } from "./routes/LinkLobby";
import { Play } from "./routes/Play";
import { Profile } from "./routes/Profile";
import { Token } from "./routes/Token";
import { PlayerProvider } from "./state/PlayerContext";
import { useWallet, WalletProvider } from "./wallet/WalletProvider";

function Nav() {
  const { wallet, auth } = useWallet();
  return (
    <header className="nav">
      <NavLink to="/" className="brand">
        RedChain
      </NavLink>
      <nav>
        <NavLink to="/play">Play</NavLink>
        <NavLink to="/collection">Collection</NavLink>
        <NavLink to="/token">Token</NavLink>
        <NavLink to="/help">Help</NavLink>
        <NavLink to="/link">Link</NavLink>
        {auth && wallet ? <NavLink to="/profile">{shortAddress(wallet.address)}</NavLink> : <NavLink to="/">Log in</NavLink>}
      </nav>
    </header>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <WalletProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Nav />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/play" element={<Play />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/token" element={<Token />} />
              <Route path="/help" element={<Help />} />
              <Route path="/link" element={<LinkLobby />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </BrowserRouter>
        </PlayerProvider>
      </WalletProvider>
    </ErrorBoundary>
  );
}
